import { createMuiTheme } from '@material-ui/core/styles';
import theme from 'styles/theme';

const baseMuiTheme = {
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
    MuiList: {
      disablePadding: true
    },
    MuiListItem: {
      disableGutters: true
    }
  },
  boxShadows: {
    MuiCard: {
      base: theme.constants.boxShadows.normal,
      selected: theme.constants.boxShadows.selected
    }
  }
};

export const createCustomColorTheme = ({
  primaryColor,
  secondaryColor,
  bodyColor
}) => {
  return createMuiTheme({
    ...baseMuiTheme,
    constants: theme.constants,
    fonts: theme.fonts,
    overrides: theme.overrides,
    palette: theme.createPalette(primaryColor, secondaryColor, bodyColor),
    typography: theme.typography
  });
};
